export const AUTH_KEY = 'asd;fkasdjfljl;kjds;lfkjasdflkj';
